import { $http } from "@/assets/js/appFunc";

const header = { bpmSessionId: "a" };

export const getAppsList = (context) => {
    if (context.state.appList.length === 0) {
        const firstReq = {
            type: "GET",
            url: "/processDefinition/Marketplace/list/detailed",
            data: null
        };
        $http(firstReq).then(
            data => {
                const detailedList = data.data;
                const secondReq = {
                    type: "GET",
                    url: "/processDefinition/Marketplace/listApplicationRevisionInstalls",
                    data: null
                };
                $http(secondReq).then(
                    data => {
                        const payload = {
                            detailed: detailedList,
                            install: data.data
                        };
                        context.commit("setAppList", payload);
                    },
                    error => console.log(error)
                );
            },
            error => console.log(error)
        );
    }
};

export const removeApp = (context, app) => {
    const payload = {
        applicationId: app.applicationId,
        installedApplicationRevisionId: app.installedRevision,
        toBeInstalledApplicationRevisionId: null
    };

    const req = {
        type: "POST",
        url: "/processDefinition/Marketplace/scheduleApplicationRevisionInstall",
        data: payload
    };

    $http(req).then(
        data => context.commit("uninstallApp", app),
        error => console.log(error)
    );
};

export const installApp = (context, app) => {
    const payload = {
        applicationId: app.applicationId,
        installedApplicationRevisionId: app.installedRevision,
        toBeInstalledApplicationRevisionId: app.revisions[0].applicationRevisionId
    };

    const req = {
        type: "POST",
        url: "/processDefinition/Marketplace/scheduleApplicationRevisionInstall",
        data: payload
    };

    $http(req).then(
        data => context.commit("installApp", app),
        error => console.log(error)
    );
};

export const updateApp = (context, app) => {
    const payload = {
        applicationId: app.applicationId,
        installedApplicationRevisionId: app.installedRevision,
        toBeInstalledApplicationRevisionId: app.revisions[0].applicationRevisionId
    };

    const req = {
        type: "POST",
        url: "/processDefinition/Marketplace/scheduleApplicationRevisionInstall",
        data: payload
    };

    $http(req).then(
        data => context.commit("updateApp", app),
        error => console.log(error)
    );
};

export const syncApps = (context) => {
    const req = {
        type: "PUT",
        url: "/marketplace/applications/sync",
        data: null
    };

    $http(req).then(
        data => {},
        error => console.log(error)
    );
};
